import React, { useState } from 'react';
import {
    PlusOutlined
} from '@ant-design/icons';
import {
    Button,
    Form,
    Input,
    Modal,
    AutoComplete,
    Row,
    Col,
    InputNumber,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';
import rawProvince from '../../../utils/province.json';

export default function AddFormModal() {
    const [result, setResult] = useState([]);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);

    const [messageApi, contextHolder] = message.useMessage();

    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/warehouse/', data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => form.resetFields()
                    });
                    queryClient.invalidateQueries(['/api/warehouse'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate(values))
            .catch(err => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                });
            })
    };

    const onCancelCreate = () => {
        form.resetFields();
        setOpen(false);
    }

    const handleDistrictSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.district.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const handleAmphoeSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.amphoe.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const handleProvinceSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.province.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const onSelect = info => {
        const splitTambon = info.split('/');
        form.setFieldsValue({
            sub_district: splitTambon[0],
            district: splitTambon[1],
            province: splitTambon[2],
            postalcode: splitTambon[3]
        })
    };

    // console.log(rawProvince);
    return (
        <div>
            {contextHolder}
            <Button
                type='primary'
                icon={<PlusOutlined />}
                onClick={() => setOpen(true)}
            >เพิ่ม</Button>
            <Modal
                open={open}
                title="เพิ่มคลังสินค้า"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        ยกเลิก
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        ตกลง
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name='addWarehouse'
                >
                    <Form.Item
                        name="name"
                        label="ชื่อ"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item name="address" label="ที่อยู่">
                        <Input.TextArea rows={2} />
                    </Form.Item>
                    <Row gutter={[8, 8]}>
                        <Col xs={12}>
                            <Form.Item
                                label="ตำบล"
                                name="sub_district"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <AutoComplete
                                    onSelect={onSelect}
                                    onSearch={handleDistrictSearch}
                                >
                                    {result.map((tam) => (
                                        <AutoComplete.Option key={tam} value={tam}>
                                            {tam}
                                        </AutoComplete.Option>
                                    ))}
                                </AutoComplete>
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                label="อำเภอ"
                                name="district"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <AutoComplete
                                    onSelect={onSelect}
                                    onSearch={handleAmphoeSearch}
                                >
                                    {result.map((amp) => (
                                        <AutoComplete.Option key={amp} value={amp}>
                                            {amp}
                                        </AutoComplete.Option>
                                    ))}
                                </AutoComplete>
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                label="จังหวัด"
                                name="province"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <AutoComplete
                                    onSelect={onSelect}
                                    onSearch={handleProvinceSearch}
                                >
                                    {result.map((prov) => (
                                        <AutoComplete.Option key={prov} value={prov}>
                                            {prov}
                                        </AutoComplete.Option>
                                    ))}
                                </AutoComplete>
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                label="รหัสไปรษณีย์"
                                name="postalcode"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>

    )
}
